/** @jsx jsx */
// eslint-disable-next-line no-unused-vars
import { jsx } from '@emotion/react';
// eslint-disable-next-line no-unused-vars
import React, { useState, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { loadLanguagePack } from '@americanexpress/one-app-ducks';
import oneAppModuleWrapper from '@americanexpress/one-app-module-wrapper';
import { browserHistory } from '@americanexpress/one-app-router';
import PropTypes from 'prop-types';
// eslint-disable-next-line no-unused-vars
import SharedScript from '@americanexpress/shared-scripts';
// eslint-disable-next-line no-unused-vars
import { callFxgApi, FxLoadingComponent } from 'axp-fx-common';
import { compose } from 'redux';
// eslint-disable-next-line no-unused-vars
import Helmet from 'react-helmet';
import { composeModules } from 'holocron';
import { combineReducers } from 'redux-immutable';
import childRoutes from '../childRoutes';
import userReducer from '../redux/reducers/user';
import helpMenuReducer from '../redux/reducers/help';
// eslint-disable-next-line no-unused-vars
import Header from './Header/Header';
// eslint-disable-next-line no-unused-vars
import Footer from './Footer/Footer';
import { isUnprotectedPath } from '../util/pathUtil';
import { dispatchLoginData } from '../redux/reducers/user/login';
import { apiPaths } from '../constants/paths';

const moduleName = 'axp-secure-file-express-root';

export const AxpSecureFileExpressRoot = (props) => {
  const { children, locale } = props;
  const [loading, setLoading] = useState(true);
  const [isUserAuthenticated, setUserAuthenticated] = useState(false);

  const fxgApiHost = useSelector((state) => state.getIn(['config', 'fxgApi']));

  const path = window.location.pathname;
  const isUnprotected = isUnprotectedPath(path);

  const isLocalEnvironment = process.env.NODE_ENV === 'development';

  const internetIdentityBaseUrls = useSelector((state) => state.getIn(['config', 'intranetIdentityBaseUrl']));
  const appBaseUrls = useSelector((state) => state.getIn(['config', 'appBaseUrl']));
  const redirectUrl = `${internetIdentityBaseUrls}/en-US/account/logout?DestPage=${appBaseUrls}`;

  // const navigate = () => {
  //   window.location.href = path;
  // };

  const dispatch = useDispatch();
  const dispatchUserData = useCallback((data) => dispatch(dispatchLoginData(data)), [dispatch]);

  let intervalTimer;

  useEffect(() => {
    window.console.log('useEffect called ');
    if (isUserAuthenticated && !isUnprotected) {
      window.AmexSession?.options({
        target: encodeURIComponent(appBaseUrls),
        locale: 'en-US',
      });
      window.console.log('loading set to true ');
      setLoading(true);
      const getUserDetails = async () => {
        window.console.log('getUserDetails called ');
        const { response, hasErrors, status } = await callFxgApi(
          `${fxgApiHost}${apiPaths.user}`,
          'GET',
          null
        );
        window.console.log('getUserDetails call done');
        if (!hasErrors) {
          window.console.log('NOT has error from user api');
          setLoading(false);
          dispatchUserData(response?.data);
          clearInterval(intervalTimer);
          //   navigate();
        } else if (!status || status === 401) {
          window.console.log('401 error');
          window.location.assign(redirectUrl);
        } else {
          window.console.log('set laoding false');
          setLoading(false);
          browserHistory.push({ pathname: 'error' });
        }
      };
      getUserDetails();
    }
  }, [
    appBaseUrls,
    dispatchUserData,
    fxgApiHost,
    internetIdentityBaseUrls,
    intervalTimer,
    isUnprotected,
    isUserAuthenticated,
    redirectUrl,
  ]);

  const loginResponseHandler = ({ statusCode }) => {
    // const loginUrl = `${internetIdentityBaseUrls}/en-US/account/light/login?DestPage=${appBaseUrls}`;
    window.console.log('loginResponseHandler');
    if (statusCode === 0) {
      window.console.log('statusCode is 0');
      window.AmexSession.closeSessionFrame();
      setUserAuthenticated(true);
    } else {
      window.console.log('statusCode is NOT 0');
      window.location.reload();
    }
    window.console.log(`MYCA login status code: ${statusCode}`);
    window.AmexSession.closeSessionFrame();
  };

  // let testSessionTimer;

  // useEffect(() => {
  //   const testSession = async () => {
  //     const isAmexSessionLoaded = window && window.AmexSession;
  //     window.console.log(`Logging HS - isAmexSessionLoaded #2 - ${isAmexSessionLoaded}`);
  //     if (isAmexSessionLoaded) {
  //       const authenticated = window.AmexSession.isAuthenticated();
  //       window.console.log(`Logging HS - isAuthenticated #2 - ${authenticated}`);
  //       if (authenticated) {
  //         window.console.log(`Logging HS - inside isAuthenticated #2 - ${authenticated}`);
  //         window.AmexSession.closeSessionFrame();
  //         clearInterval(intervalTimer);
  //         setUserAuthenticated(true);
  //       }
  //       clearInterval(testSessionTimer);
  //     }
  //   };
  //   testSessionTimer = setInterval(testSession, 1000);
  // }, []);

  useEffect(() => {
    const checkSession = async () => {
      const isAmexSessionLoaded = window && window.AmexSession;

      window.console.log(`Logging HS - isAmexSessionLoaded - ${isAmexSessionLoaded}`);

      // Call login function to load one-login iframe
      if (isAmexSessionLoaded) {
        clearInterval(intervalTimer);
        const authenticated = window.AmexSession.isAuthenticated();
        window.console.log(`Logging HS - isAuthenticated - ${authenticated}`);
        if (authenticated) {
          window.AmexSession.closeSessionFrame();
          setUserAuthenticated(true);
        } else {
          window.AmexSession.login({
            autoClose: true,
            style: 'light',
            callback: loginResponseHandler.bind(this),
          });
        }
      } else {
        window.console.log(`Logging HS - isAmexSessionLoaded - ${isAmexSessionLoaded}`);
      }
    };

    if (isUnprotected || isLocalEnvironment) {
      setUserAuthenticated(true);
      setLoading(false);
    } else {
      window.console.log(`Logging HS - locale - ${locale}`);
      // Execute every second to make sure MYCA login page opens without delay.
      intervalTimer = setInterval(checkSession, 1000);
    }
  }, []);

  return (
    <React.Fragment>
      <Helmet
        {...{
          link: [
            {
              rel: 'stylesheet',
              href: 'https://www.aexp-static.com/cdaas/one/statics/@americanexpress/dls/6.25.4/package/dist/6.25.4/styles/dls.min.css',
            },
          ],
          script: [
            {
              type: 'text/javascript',
              src: 'https://www.aexp-static.com/cdaas/one/statics/@americanexpress/dls/6.25.4/package/dist/6.25.4/scripts/dls.min.js',
            },
            // {
            //   type: 'text/javascript',
            //   src: 'https://cdaas-dev.americanexpress.com/one/one-identity-session/1.29.1-2/timeout.js',
            // },
          ],
        }}
      />

      <SharedScript name="one-identity-session" version="^1.0.0" windowCheck="AmexSession" />

      <div style={{ minWidth: '1024px' }}>
        {loading ? (
          <FxLoadingComponent />
        ) : (
          <>
            <Header isAuthenticated={isUserAuthenticated} isUnprotected={isUnprotected} />
            <main style={{ minHeight: '380px' }}>{children}</main>
            {isUserAuthenticated && <Footer />}
          </>
        )}
      </div>
    </React.Fragment>
  );
};

AxpSecureFileExpressRoot.propTypes = {
  locale: PropTypes.string.isRequired,
  children: PropTypes.node,
};

AxpSecureFileExpressRoot.childRoutes = childRoutes;

/* istanbul ignore next */
if (!global.BROWSER) {
  AxpSecureFileExpressRoot.appConfig = require('../config/appConfig').default;
}

export const load = () => (dispatch) => dispatch(composeModules([{ name: 'axp-secure-file-express-portal' }]));

export const loadModuleData = async ({ store }) => {
  const { dispatch } = store;
  await dispatch(loadLanguagePack(moduleName, { fallbackLocale: 'en-US' }));
};

AxpSecureFileExpressRoot.holocron = {
  name: moduleName,
  reducer: combineReducers({
    userData: userReducer,
    helpMenuData: helpMenuReducer,
  }),
  loadModuleData,
  load,
};

const hocChain = compose(oneAppModuleWrapper(moduleName));

export default hocChain(AxpSecureFileExpressRoot);
